import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isSidebarWhite: false,
  },
  mutations: {
    setSideBar (state, data) {
      state.isSidebarWhite = data
    },
  },
  getters: {
    sidebar: state => state.isSidebarWhite,
  },
  actions: {},
})
